import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

import { Choice } from "./Choice";

interface ChoiceContainerProps {
    bindingPath: AbsoluteModelPath;
    viewModelSelect: ViewModelSelect;
}

const mapStateToProps = (state: FullFormState, ownProps: ChoiceContainerProps) => ({
    value: ownProps.viewModelSelect.controlModel(state, ownProps.bindingPath).value ?? "",
});

export const ChoiceContainer = withResolvePaths(withViewModelSelect(connect(mapStateToProps)(Choice)));
